export default function Ionic() {
  return (
    <div
      className="ion-icon-ionic"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g>
	<path d="M423.592,132.804C427.006,127.714,429,121.59,429,115c0-17.675-14.33-32-32-32c-6.59,0-12.714,1.994-17.805,5.409
		C344.709,63.015,302.11,48,256,48C141.125,48,48,141.125,48,256c0,114.877,93.125,208,208,208c114.873,0,208-93.123,208-208
		C464,209.889,448.984,167.29,423.592,132.804z M391.83,391.832c-17.646,17.646-38.191,31.499-61.064,41.174
		c-23.672,10.012-48.826,15.089-74.766,15.089c-25.94,0-51.095-5.077-74.767-15.089c-22.873-9.675-43.417-23.527-61.064-41.174
		s-31.5-38.191-41.174-61.064C68.982,307.096,63.905,281.94,63.905,256c0-25.94,5.077-51.095,15.089-74.767
		c9.674-22.873,23.527-43.417,41.174-61.064s38.191-31.5,61.064-41.174C204.905,68.982,230.06,63.905,256,63.905
		c25.939,0,51.094,5.077,74.766,15.089c13.446,5.687,26.08,12.83,37.802,21.327C366.293,104.719,365,109.707,365,115
		c0,17.675,14.327,32,32,32c5.293,0,10.28-1.293,14.678-3.568c8.498,11.721,15.641,24.355,21.327,37.801
		c10.013,23.672,15.09,48.827,15.09,74.767c0,25.939-5.077,51.096-15.09,74.768C423.33,353.641,409.478,374.186,391.83,391.832z"/>
	<circle cx="256.003" cy="256" r="96"/>
</g>
</svg>
`,
      }}
    />
  )
}
